"use strict"

class Header {
    constructor() {
        this.hamburgerSrc = document.querySelector('.hamburger').src;
        this.hamburgerCrossSrc = document.querySelector('.cross').src;
    }

    init() {
        document.querySelectorAll('.menu-item-has-children > a').forEach((element) => element.addEventListener('click', this.toggleDropdown));
        document.querySelector('.hamburger').addEventListener('click', () => this.toggleMobileMenu());

        //Set the submenus width dynamically
        this.setSubmenuWidth();
        this.setFontsize();
        window.addEventListener('resize', this.setFontsize);
    }

    toggleMobileMenu() {
        let hamburger = document.querySelector('.hamburger');
        let logo = document.querySelector('a.nav-logo');

        hamburger.src = (hamburger.src === this.hamburgerCrossSrc) ? this.hamburgerSrc : this.hamburgerCrossSrc;
        document.getElementById("header").classList.toggle('mobile-active');
        logo.classList.toggle('mobile');
    }

    toggleDropdown(e) {
        const dropdownArrowWidth = 22;
        const tabletBreakpoint = 1200;

        // If the click is on the after element (the arrow)
        // Stop the redirection
        // And toggle the dropdown
        if (window.innerWidth < tabletBreakpoint && e.offsetX >= e.target.offsetWidth - dropdownArrowWidth) {
            e.preventDefault();
            this.parentNode.querySelector('.sub-menu').classList.toggle('sub-menu--active');
            this.parentNode.classList.toggle('menu-item-has-children--active');
        }
    }

    setSubmenuWidth() {
        const offsetMenu = document.querySelector('.menu-item').offsetLeft;
        const menuWidth = document.querySelector('.menu').offsetWidth;

        document.querySelectorAll('.menu-item-has-children').forEach((element) => this.setSubmenuStyle(element, offsetMenu, menuWidth));
    }

    setSubmenuStyle(element, offsetMenu, menuWidth) {
        const subMenu = element.querySelector('.sub-menu');

        subMenu.style.left = offsetMenu - element.offsetLeft + "px";
        subMenu.style.minWidth = menuWidth + "px";
    }

    setFontsize() {
        const windowWidth = window.innerWidth;
        const fontSizeXxl = 20;
        const breakpointXxl = 1600;
        const navLinks = document.querySelector('.nav-links');

        if (windowWidth > 1200 && windowWidth < breakpointXxl) {
            navLinks.style.fontSize = (windowWidth * fontSizeXxl) / breakpointXxl + "px";
        } else if (windowWidth <= 1200) {
            navLinks.style.fontSize = "24px";
        }
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/scripts/components/Header.js